// extracted by mini-css-extract-plugin
export var statItem = "_kp-1";
export var statsRow = "_kp-0";